
import { createContext, useState, useEffect, useContext } from 'react';

const DashboardContext = createContext();
const channel = new BroadcastChannel('dashboard-channel');

export const DashboardProvider = ({ children }) => {
  const [activeView, setActiveViewState] = useState('integratedControl');

  const updateActiveView = (view) => {
    channel.postMessage({ type: 'VIEW_CHANGED', view });
    setActiveViewState(view);
  };

const [mapMessages, setMapMessages] = useState([]);

const sendMessageToMap = (message) => {
  channel.postMessage({ type: 'MAP_MESSAGE', message });
  setMapMessages((prev) => [...prev, message]);
};

useEffect(() => {
  const handler = (event) => {
    const { type, view, message } = event.data;
    if (type === 'VIEW_CHANGED') {
      setActiveViewState(view);
    } else if (type === 'MAP_MESSAGE') {
      setMapMessages((prev) => [...prev, message]);
    }
  };

  channel.addEventListener('message', handler);
  return () => channel.removeEventListener('message', handler);
}, []);

const clearLastMapMessage = () => {
  setMapMessages((prev) => prev.slice(0, -1));
};

const clearAllMapMessages = () => {
  setMapMessages([]);
};

const value = {
  activeView,
  setActiveView: updateActiveView,
  mapMessages,
  sendMessageToMap,
  clearLastMapMessage,      
  clearAllMapMessages,      
};

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => useContext(DashboardContext);